import apiClient from './client'

/**
 * 认证相关 API
 */
export const authApi = {
  /**
   * Telegram 登录
   * @param {string} initData - Telegram initData
   * @returns {Promise} 登录响应
   */
  telegramLogin(initData) {
    return apiClient.post('/auths/telegram/login', {
      initData: initData
    }, {
      skipLoading: true,
    })
  },

  /**
   * 邮箱登录
   * @param {string} email - 邮箱地址
   * @param {string} password - 密码
   * @returns {Promise} 登录响应
   */
  login(email, password) {
    const params = new URLSearchParams()
    params.append('username', email)
    params.append('password', password)
    return apiClient.post('/auths/login/', params.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  /**
   * 发送注册验证码
   * @param {string} email - 邮箱地址
   * @param {string} platform - 平台标识（可选）
   * @returns {Promise} 发送验证码响应
   */
  sendRegisterCode(email, platform = 'web', turnstileToken = null) {
    const headers = { platform }
    if (turnstileToken) {
      headers['CF-Turnstile-Response'] = turnstileToken
    }
    return apiClient.post(`/auths/register/send-code/?email=${encodeURIComponent(email)}`, { email }, {
      headers
    })
  },

  /**
   * 注册
   * @param {Object} data - 注册数据
   * @param {string} data.Email - 邮箱地址
   * @param {string} data.Password - 密码
   * @param {string} data.Username - 用户名
   * @param {string} data.VerificationCode - 验证码
   * @param {string} [data.ReferrerCode] - 邀请码（可选）
   * @param {boolean} [data.ReceivePromotionalEmails] - 是否接收促销邮件（可选）
   * @returns {Promise} 注册响应
   */
  register(data, turnstileToken = null) {
    const headers = {}
    if (turnstileToken) {
      headers['CF-Turnstile-Response'] = turnstileToken
    }
    return apiClient.post('/auths/register/', data, { headers })
  },

  /**
   * 发送重置密码验证码
   * @param {string} email - 邮箱地址
   * @returns {Promise} 发送验证码响应
   */
  sendResetPasswordCode(email) {
    return apiClient.post(`/auths/reset-password/send-code/?email=${encodeURIComponent(email)}`, { email })
  },

  /**
   * 重置密码
   * @param {Object} data - 重置密码数据
   * @param {string} data.Email - 邮箱地址
   * @param {string} data.Password - 新密码
   * @param {string} data.VerificationCode - 验证码
   * @returns {Promise} 重置密码响应
   */
  resetPassword(data) {
    return apiClient.post('/auths/reset-password/', data)
  },

  /**
   * 获取当前用户信息
   * @returns {Promise} 用户信息响应
   */
  getUserInfo() {
    return apiClient.get('/users/me/')
  },

  updateUserLanguage(language) {
    return apiClient.put('/users/me/lang/', null, {
      headers: {
        'Accept-Language': language
      },
      skipLoading: true,
      skipErrorHandler: true
    })
  },

  /**
   * 获取邀请用户列表
   * @returns {Promise} 邀请用户列表响应
   */
  getInvitees() {
    return apiClient.get('/users/me/invitees/')
  }
}
